<div class="app-footer" style="height: 40px;">  
  <div class="app-footer__inner" style="height: 40px;">
    <div class="app-footer-left">
      <span style="font-size: 12px;">{{version}}</span>
    </div>
    <div class="app-footer-right">
     <span style="font-size: 12px;">
        <a href="https://theappsherpa.com/terms-conditions/" target="_blank">Terms of Use</a>&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="https://theappsherpa.com/privacy-policy/" target="_blank">Privacy Policy</a>&nbsp;&nbsp;&nbsp;&nbsp;
        Copyright &copy; {{currentYear}} TheAppSherpa. All rights reserved.
      </span>
    </div>
  </div>
</div>
